export default {"src":"/_next/static/media/book.6828b5bb.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};